import { useEffect, useState } from "react"

import { formatters } from "@garantidos/utils"

import { useStep } from "@mobi/libraries/step"

import { useProposalContext } from "contexts/proposal"

import { accordionData, alternativeLabel, fields } from "./data"

const useSummaryAccordion = () => {
  const [completeData, setCompleteData] = useState([])
  const { proposalData, fetchProposalData, errorHandler } = useProposalContext()
  const { prev } = useStep()

  const getData = (proposalDataParam) => {
    accordionData.forEach(({ infoOrder, data }) => {
      const tempData = data

      infoOrder.forEach((info, index) => {
        tempData[index] = {}
        const field = fields[info]
        if (
          (info === "homeInsurance" &&
            proposalDataParam.property_type === "COMERCIAL") ||
          !field
        )
          return

        const rawValue = proposalDataParam[field.name]
        if (rawValue === undefined) return

        const formatter =
          field.type === "currency"
            ? formatters.fetchFormatters.displayableNumber
            : formatters.fetchFormatters[field.fetchFormat]

        let value
        if (field.type === "checkbox") {
          value = rawValue ? "Sim" : "Não"
        } else {
          value = formatter
            ? formatter({
                value: rawValue,
                options: field.options,
                accents: true
              })
            : rawValue
        }

        const label = alternativeLabel[info] || field.label

        tempData[index] = {
          label,
          value,
          type: field.type
        }
      })
    })

    return accordionData
  }

  useEffect(() => {
    const infoData = getData(proposalData)
    setCompleteData(infoData)
  }, [])

  const handleClickEdit = async (targetStep) => {
    try {
      await fetchProposalData({ step: targetStep, recaptcha: true })
      prev(targetStep)
    } catch (error) {
      errorHandler(error)
    }
  }

  return {
    completeData,
    handleClickEdit
  }
}

export default useSummaryAccordion
